import React, { useState, useEffect } from "react";

import { LoadingOutlined,UserOutlined } from "@ant-design/icons";
import { Modal, Input } from "antd";
import { motion } from "framer-motion";
import Interweave from "interweave";
import ReactPlayer from "react-player";
import { useSelector } from "react-redux";

import { isValidURL } from "../../../helper/service";
import { DecryptObjectData } from "../../../utilities";
import bandStyles from "./BandConfiguration.module.css";
import styles from "./TabContent.module.css";
import tabs from "./tabs";
import { tabContentVariant, sideCardVariants } from "./variants";


const TabContent = ({
  id,
  data,
  active,
  activeTabIndex,
  tabsCount,
  onTabClick,
  children,
  error,
  faqData,
  onBookNow,
  completedTabs,
  notes,
  eventType,
  saveNote,
  discount,
  discountAccess,
  saveDiscount,
  saveEventNotes,
  saveDiscountValue,
  bookNowLoading,
  disableAction
}) => {
  const [isAuthenticated, setIsAuthenticate] = useState(false);
  const [noteModalVisiable, setNoteModalVisiable] = useState(false);
  const [discountModalVisiable, setDiscountModalVisiable] = useState(false);
  const [faqModalVisiable, setFaqModalVisiable] = useState(false);
  const [playing, setPlaying] = useState(false);
  const auth = useSelector((state) => state.auth);
  useEffect(() => {
    if (auth && auth.token) {
      setIsAuthenticate(true);
    } else {
      setIsAuthenticate(false);
    }
  }, [auth]);

  const handlePlay = () => {
    setPlaying(true);
  };

  const handleSaveNotes = () => {
    saveEventNotes();
    setNoteModalVisiable(false);
  };
  const handleSaveDiscount = () => {
    saveDiscountValue();
    setDiscountModalVisiable(false);
  };
  const handleCancelDiscount = () => {
    setDiscountModalVisiable(false);
  };

  return (
    <motion.div
      id={id}
      role="tabpanel"
      className={styles["bandSection-container"]}
      variants={tabContentVariant}
      animate={active ? "active" : "inactive"}
      initial="inactive"
    >
      <motion.div className={styles["side-card"]} variants={sideCardVariants}>
        <motion.div
          className={`d-flex justify-content-center align-items-center ${styles["side-card-icon"]}`}
        >
          {data.icon}
        </motion.div>
        <div className={styles["title-text"]}>
          <h2>{data.title}</h2>
          <h2>{data.subTitle}</h2>
        </div>
        <div className={styles["tab-indicator-container"]}>
          <ul className={styles["tab-indicator"]} role="tablist">
            {tabs.map((tab, index) => (
              <motion.li
                key={index}
                style={{
                  height: `${tabs[activeTabIndex].barHeights[index]}px`,
                }}
                className={`${styles["step-bar"]}
                ${activeTabIndex === index ? styles.active : styles.inactive}
                ${
                  completedTabs.includes(index)
                    ? styles.complete
                    : styles.incomplete
                }
                `}
                role="presentation"
              >
                <span>{index + 1}</span>
              </motion.li>
            ))}
          </ul>
        </div>
      </motion.div>
      <div
        className={`${bandStyles["add-note-popup"]} ${bandStyles["mobile_note_popup"]}`}
      >
        {(id === "segment-content"
          ? eventType?.toLowerCase() === "wedding"
          : true) && (
          <button
            className={styles["faq-button"]}
            onClick={() => setFaqModalVisiable(true)}
            id="faq-ques-link"
          >
            <img alt="FAQ" src={"/assets/icons/faq-icon.svg"} />
            <span>
              FAQ<sup>*</sup>
            </span>
          </button>
        )}
        <button
          className={styles["notes-button"]}
          onClick={() => setNoteModalVisiable(true)}
        >
          <img alt="Note" src={"/assets/icons/add-note-icon.svg"} />
          <span>Notes</span>
        </button>
      </div>
      <motion.div className={styles["main-card"]}>
        {error ? (
          <div className="d-flex justify-content-center align-items-center h-100 mt-2">
            <p className="band-config-table-errMsg">{error}</p>
          </div>
        ) : (
          <div className={styles["main-card-body"]}>{children}</div>
        )}
        <div className={styles["main-card-footer"]}>
          <div className={`${bandStyles["add-note-popup-mobile"]}`}>
            {(id === "segment-content"
              ? eventType?.toLowerCase() === "wedding"
              : true) && (
              <button
                className={styles["faq-button"]}
                onClick={() => setFaqModalVisiable(true)}
              >
                <img alt="FAQ" src={"/assets/icons/faq-icon.svg"} />
                <span>
                  FAQ<sup>*</sup>
                </span>
              </button>
            )}
            <Modal
              title="FAQ"
              wrapClassName={bandStyles["faq-pop-modal"]}
              centered
              visible={faqModalVisiable}
              onOk={() => setFaqModalVisiable(false)}
              onCancel={() => setFaqModalVisiable(false)}
              destroyOnClose
            >
              <ReactPlayer
                url={faqData?.video}
                light={`"${
                  isValidURL(faqData?.image)
                    ? faqData?.image
                    : process.env.IMAGE_LINK + faqData?.image
                }"`}
                playing={playing}
                playIcon={
                  <img
                    src={"/assets/images/play_icon.svg"}
                    alt="play-icon"
                    onClick={handlePlay}
                    style={{
                      backgroundColor: "black",
                      padding: "1rem",
                      borderRadius: "50%",
                    }}
                  />
                }
                width="100%"
                controls
              />
              <h4>{faqData?.question}</h4>
              <p>
                <Interweave allowElements={false} content={faqData?.answer} />
                <div className={styles["modal-para-bottom"]}></div>
              </p>
            </Modal>
            <button
              className={styles["notes-button"]}
              onClick={() => setNoteModalVisiable(true)}
              id="notes-link"
            >
              <img alt="Note" src={"/assets/icons/add-note-icon.svg"} />
              <span>Notes</span>
            </button>
            <Modal
              title="Add Note"
              wrapClassName={bandStyles["addnote-pop-modal"]}
              centered
              visible={noteModalVisiable}
              okText="Save"
              onOk={() => handleSaveNotes()}
              onCancel={() => setNoteModalVisiable(false)}
            >
              <Input.TextArea
                rows={5}
                value={notes}
                onChange={(event) => saveNote(event)}
                placeholder="Type your suggestion here"
              />
              {!isAuthenticated && (
                <p className="error mt-2">
                  Please log in or sign up to save your note
                </p>
              )}
            </Modal>
          </div>
          <div className={bandStyles.mobile_next_prev_btn}>
          <Modal
              title="Add Discount"
              style={{width:"350px !important"}}
              wrapClassName={`${bandStyles["addnote-pop-modal"]} ${bandStyles["add-discount-popup"]}`}
              centered
              visible={discountModalVisiable}
              okText="Save"
              onOk={() => handleSaveDiscount()}
              onCancel={() => handleCancelDiscount()}
            >
              <div className={styles.iconTextbox}>
              <Input
                value={discount}
                onChange={(event) => saveDiscount(event)}
                placeholder=""
                className={styles.textbox}
              />
              </div>
              <span className={styles.icon}>$</span>
              {!isAuthenticated && (
                <p className="error mt-2">
                  Please log in or sign up to add discount
                </p>
              )}
            </Modal>
            {discountAccess ? 
            <button
              onClick={() => setDiscountModalVisiable(true)}
              className={`${styles["tab-buttons"]} ${styles["discount"]}`}
              id="book-now-btn"
            >
              {(!discount || discount === '0') ? (
                "Add Discount"
              ) : (
                "Discount - $"+discount
              )}
            </button> :
            (!discount || discount === '0') ? (
                ""
              ) : (
                "Discount - $"+discount
              )}
            
            {activeTabIndex > 0 && (
              <button
                onClick={() => onTabClick(activeTabIndex - 1)}
                className={`${styles["tab-buttons"]} ${styles["prev"]}`}
              >
                <span>Back</span>
              </button>
            )}
            {activeTabIndex < tabsCount - 1 && (
              <button
                onClick={() => onTabClick(activeTabIndex + 1)}
                className={`${styles["tab-buttons"]} ${styles["next"]}`}
                id="next-item-btn"
              >
                Next
              </button>
            )}
            <button
              onClick={() => onBookNow()}
              className={`${styles["tab-buttons"]} ${styles["book-now"]}`}
              disabled={disableAction}
              id="book-now-btn"
            >
              {!bookNowLoading ? (
                "Book Now"
              ) : (
                <LoadingOutlined style={{ fontSize: 24 }} spin />
              )}
            </button>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default TabContent;
